import { BaseRequest, IBaseRequest } from "../../BaseRequest";

export interface ILogoutRequest extends IBaseRequest{
}

export class LogoutRequest extends BaseRequest implements ILogoutRequest{
    toXml(): string {
        return super.wrapperXml("Logout", super.toXml());
    }
}